import { NotificationMessageDto } from "@/modules/types/notification/notification";
import { apiClient, ApiClient } from "@/lib/api/api-client";
import { BaseResponse } from "@/modules/types/response";

export interface NotificationResponse extends BaseResponse {
  notifications: NotificationMessageDto[];
  total: number;
  nextId: string;
}

export class NotificationService {
  private BASE_PATH =
    process.env.API_NOTIFICATION_ENDPOINT ||
    "http://localhost:8004/notification";
  private apiClient: ApiClient = apiClient;
  private apiVersion = "v1.0.0";
  constructor(apiVersion?: string) {
    this.apiVersion = apiVersion || this.apiVersion;
  }

  async getNotifications(
    candidateId: string,
    page?: number,
    limit?: number,
    isRead?: boolean,
    isSeen?: boolean,
    nextId?: string
  ): Promise<NotificationResponse> {
    const queryParams = new URLSearchParams();
    if (page) queryParams.append("page", page.toString());
    if (limit) queryParams.append("limit", limit.toString());
    if (isRead !== undefined) queryParams.append("isRead", isRead.toString());
    if (isSeen !== undefined) queryParams.append("isSeen", isSeen.toString());
    if (candidateId) queryParams.append("candidateId", candidateId);
    if (nextId) queryParams.append("nextId", nextId);
    return await this.apiClient.fetch<NotificationResponse>(
      `${this.BASE_PATH}/${
        this.apiVersion
      }/candidate/list?${queryParams.toString()}`
    );
  }

  async seenNotification(candidateId: string, notiId: string) {
    return await this.apiClient.fetch<BaseResponse>(
      `${this.BASE_PATH}/${this.apiVersion}/seen?candidateId=${candidateId}&notificationId=${notiId}`,
      {
        method: "POST",
      }
    );
  }

  async markAllAsRead(candidateId: string) {
    return await this.apiClient.fetch<BaseResponse>(
      `${this.BASE_PATH}/${this.apiVersion}/mark-all-read?candidateId=${candidateId}`,
      {
        method: "POST",
      }
    );
  }
}

export const notificationService = new NotificationService();
